import { useEffect } from 'react'

import initializeFaro from '../../config/faroConfig'
import { useEnvironmentContext } from '../EnvironmentProvider'

const FaroMonitoring = ({ children }) => {
  const { grafanaFaroCollectorURL, deployEnv } = useEnvironmentContext()
  useEffect(() => {
    initializeFaro(grafanaFaroCollectorURL, deployEnv)
  }, [])

  return children
}

export default FaroMonitoring
